// extracted by mini-css-extract-plugin
export default {"genericCard":"mp-z","inline":"np-z","mastercard":"op-z","discover":"pp-z","visa":"qp-z","amex":"rp-z","active":"sp-z"};